.ui-resizable-split {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.ui-resizable-split__pane {
  position: absolute;
  top: 0;
  bottom: 0;
  min-width: 0;
  overflow: auto;
}

.ui-resizable-split__pane--left {
  left: 0;
}

/* Right pane sits above the left and is opaque, so a full ("cover") panel slides
 * over the content without forcing the left pane to reflow. */
.ui-resizable-split__pane--right {
  right: 0;
  z-index: var(--lemn-z-chrome);
  background: var(--lemn-color-canvas);
}

.ui-resizable-split__handle {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: var(--lemn-z-chrome);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--lemn-space-2);
  width: 16px;
  transform: translateX(-50%);
  cursor: col-resize;
  outline: none;
}

.ui-resizable-split__handle[data-hidden="true"] {
  display: none;
}

.ui-resizable-split__line {
  flex: 1;
  width: 1px;
  border-radius: var(--lemn-radius-pill);
  background: var(--lemn-color-border);
}

.ui-resizable-split__grip {
  display: grid;
  place-items: center;
  color: var(--lemn-color-text-muted);
}

.ui-resizable-split__handle:hover .ui-resizable-split__line {
  background: var(--lemn-color-border-strong);
}

.ui-resizable-split__handle:hover .ui-resizable-split__grip {
  color: var(--lemn-color-text);
}

.ui-resizable-split__handle[data-state="dragging"] .ui-resizable-split__line {
  background: var(--lemn-color-accent);
}

.ui-resizable-split__handle[data-state="dragging"] .ui-resizable-split__grip {
  color: var(--lemn-color-accent);
}
